import { FREE_EDITION } from '@atlassian/jira-shared-types/src/edition.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createSubscriber,
	createContainer,
	createHook,
} from '@atlassian/react-sweet-state';
import { UPFLOW_MODAL_STORE_NAME } from '../common/constants.tsx';
import type { State, StoreApi, ActionProps } from './types.tsx';

const initialState: State = {
	renderUpflowModal: false,
	product: 'jira-software',
	touchpointId: '',
	flow: 'learn-more',
	// Replace with lodash/noop
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	onClose: () => {},
	targetEdition: FREE_EDITION,
};

const actions = {
	mountUpflowModal:
		({ targetEdition, product, flow, touchpointId, subRoute, onClose, onOpen }: ActionProps) =>
		({ setState }: StoreApi) => {
			setState({
				targetEdition,
				product,
				flow,
				touchpointId,
				subRoute,
				onClose,
				onOpen,
				renderUpflowModal: true,
			});
		},
	unMountUpflowModal:
		() =>
		({ setState }: StoreApi) => {
			setState({ renderUpflowModal: false });
		},
} as const;

export type Actions = typeof actions;

const Store = createStore<State, Actions>({
	name: UPFLOW_MODAL_STORE_NAME,
	initialState,
	actions,
});

export const UpflowModalSubscriber = createSubscriber<State, Actions>(Store);
export const UpflowModalContainer = createContainer<State, Actions, null>(Store);
export const useUpflowModal = createHook(Store);
